import { useState } from "react";
import { useHistory } from "react-router-dom";
import http from "./http-service";

const HttpInterceptor = ({ children }) => {
    const history = useHistory();
    const login = "/login";

    useState(() => {
        http.interceptors.response.use(
            (response) => response,
            (error) => {
                if (error?.response) {
                    const { status } = error.response;
                    const { pathname } = history.location;

                    if (status === 401) {
                        if (pathname !== login) {
                            history.push(login);
                            window.location.reload();
                        }
                    }
                } else {
                    throw error;
                }
                return Promise.reject(error);
            },
        );
    }, []);
    return children;
};

export default HttpInterceptor;
